import { LineChart } from '@mui/x-charts/LineChart';
import ChartCard from '../../analytics/ChartCard';
import { DatabaseGrowthDataPoint } from '../../../../types/admin';

interface DatabaseGrowthChartProps {
  data: DatabaseGrowthDataPoint[];
  loading?: boolean;
}

export default function DatabaseGrowthChart({ data, loading }: DatabaseGrowthChartProps) {
  const dates = data.map((d) => new Date(d.date));
  const sizes = data.map((d) => d.size_mb);

  return (
    <ChartCard title="Database Growth" subtitle="Last 30 days" loading={loading} height={400}>
      <LineChart
        xAxis={[
          {
            data: dates,
            scaleType: 'time',
            valueFormatter: (date) => new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
          },
        ]}
        yAxis={[
          {
            label: 'Database Size (MB)',
          },
        ]}
        series={[
          {
            data: sizes,
            label: 'Database Size',
            color: '#1976d2',
            showMark: false,
            area: true,
          },
        ]}
        grid={{ vertical: false, horizontal: true }}
        sx={{
          '& .MuiLineElement-root': {
            strokeWidth: 2,
          },
        }}
      />
    </ChartCard>
  );
}
